import classnames from 'classnames';
import { func, number } from 'prop-types';
import React from 'react';
import { Col, Label, Row } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import CurrencyInput from '../../generic/CurrencyInput';
import { getProductMetaFieldName } from '../utils';

function renderCreativeBudgetLabel(label, name, index, width = 3, className) {
  return (
    <Label
      sm={width}
      for={getProductMetaFieldName(index, name)}
      className={classnames('c-campaign-line__label', className)}
    >
      {label}
    </Label>
  );
}

function renderCreativeBudgetValue(
  onChange,
  name,
  index,
  field,
  width = 3,
  plusSign = true,
) {
  return (
    <Col sm={width}>
      <CurrencyInput
        name={getProductMetaFieldName(index, name)}
        className="d-inline form-control p-0 pl-2 h-auto"
        value={field}
        style={{ width: '110px' }}
        onChange={onChange}
      />
      {plusSign && <span className="d-inline pl-4">+</span>}
    </Col>
  );
}

function CreativeBudgetBreakdown({
  onChange,
  index,
  creativeCampaignSetup,
  creativeConcept,
  creativeHandlingFee,
  creativeTalent,
  creativeDesign,
  creativeReach,
  creativeKsk,
}) {
  return (
    <>
      <Row>
        <Col sm={3} />
        <Label
          sm={2}
          for="creativeInternalCost"
          className="c-campaign-line__label"
        >
          Margin & internal cost
        </Label>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetLabel(
              'Campaign Setup',
              'creativeCampaignSetup',
              index,
            )}
            {renderCreativeBudgetLabel(
              'Concept & Consulting',
              'creativeConcept',
              index,
            )}
            {renderCreativeBudgetLabel(
              'Handling Fee',
              'creativeHandlingFee',
              index,
            )}
          </Row>
        </Col>
      </Row>

      <Row className="align-items-baseline" style={{ marginTop: '-0.4rem' }}>
        <Col sm={3} />
        <Col sm={1}>
          <CurrencyFormat
            value={
              creativeCampaignSetup + creativeConcept + creativeHandlingFee
            }
            name="creativeInternalCost"
            text
          />
        </Col>
        <Col sm={1} className="c-campaign-line__label pl-5">
          =
        </Col>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetValue(
              onChange,
              'creativeCampaignSetup',
              index,
              creativeCampaignSetup,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'creativeConcept',
              index,
              creativeConcept,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'creativeHandlingFee',
              index,
              creativeHandlingFee,
              3,
              false,
            )}
          </Row>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col sm={3} />
        <Label
          sm={2}
          for="creativeExternalCost"
          className="c-campaign-line__label"
        >
          External cost
        </Label>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetLabel('Talent', 'creativeTalent', index)}
            {renderCreativeBudgetLabel(
              'Inhouse Shooting & Design',
              'creativeDesign',
              index,
              3,
              'pr-0',
            )}
            {renderCreativeBudgetLabel(
              'Organic Influencer Reach',
              'creativeReach',
              index,
              3,
              'pr-0',
            )}
            {renderCreativeBudgetLabel('KSK', 'creativeKsk', index)}
          </Row>
        </Col>
      </Row>

      <Row className="align-items-baseline" style={{ marginTop: '-0.4rem' }}>
        <Col sm={3} />
        <Col sm={1}>
          <CurrencyFormat
            value={
              creativeTalent + creativeDesign + creativeReach + creativeKsk
            }
            name="creativeExternalCost"
            text
          />
        </Col>
        <Col sm={1} className="c-campaign-line__label pl-5">
          =
        </Col>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetValue(
              onChange,
              'creativeTalent',
              index,
              creativeTalent,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'creativeDesign',
              index,
              creativeDesign,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'creativeReach',
              index,
              creativeReach,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'creativeKsk',
              index,
              creativeKsk,
              2,
              false,
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
}

CreativeBudgetBreakdown.propTypes = {
  index: number.isRequired,
  creativeCampaignSetup: number.isRequired,
  creativeConcept: number.isRequired,
  creativeHandlingFee: number.isRequired,
  creativeTalent: number.isRequired,
  creativeDesign: number.isRequired,
  creativeReach: number.isRequired,
  creativeKsk: number.isRequired,
  onChange: func.isRequired,
};

export default CreativeBudgetBreakdown;
